import { render } from "./SelectService.vue?vue&type=template&id=accd708a"
import script from "./SelectService.vue?vue&type=script&lang=js"
export * from "./SelectService.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__